import React, { useState, useEffect } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FormLabel, Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'

function EditarCargoDirectiva(props) {
	const { cargoOriginal, guardar, setQueMostrar } = props

	const [datos, setDatos] = useState({})

	useEffect(() => {
		setDatos({
			id: cargoOriginal.id,
			nombre: cargoOriginal.nombre,
			contenido: cargoOriginal.contenido,
			orden: cargoOriginal.orden
		})

	}, [cargoOriginal])

	const handleClose = () => {
		setQueMostrar('')
		setDatos({})
	}

	const handleProcesar = (e) => {
		e.preventDefault()

		const data = {
			...datos,
		}
		
		guardar(data)
		handleClose()
	}

	const handleChange = (value, key) => {
		const datosCopia = { ...datos }
		datosCopia[key] = value
		setDatos(prev => datosCopia)
	}

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Nuevo cargo de directiva" />
			<Offcanvas.Body>
				<h1>Datos del cargo de la Junta Directiva</h1>
				{datos.id && (
					<Row>
						<Col sm={12} md={6}>
							<Form onSubmit={handleProcesar} className="ms-4">
								<Row>
									<Col>
										<Form.Group className="mb-3" controlId="cargo-nombre">
											<FormLabel>Cargo</FormLabel>
											<Form.Control
												value={datos.nombre}
												type="text"
												onChange={(e) => handleChange(e.target.value, 'nombre')}
											/>
										</Form.Group>
									</Col>
								</Row>
								<Row>
									<Col>
										<Form.Group className="mb-3" controlId="cargo-contenido">
											<FormLabel>Contenido</FormLabel>
											<Form.Control
												value={datos.contenido}
												type="text"
												as="textarea"
												rows="4"
												onChange={(e) => handleChange(e.target.value, 'contenido')}
											/>
										</Form.Group>
									</Col>
								</Row>
								<Row>
									<Col>
										<Form.Group className="mb-3 col-md-3" controlId="cargo-orden">
											<FormLabel>Orden</FormLabel>
											<Form.Control
												value={datos.orden}
												type="number"
												onChange={(e) => handleChange(e.target.value, 'orden')}
											/>
										</Form.Group>
									</Col>
								</Row>
							</Form>
						</Col>
					</Row>
				)}
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="outline-tertiary" onClick={handleClose} className="me-2">
					Cancelar
				</Button>
				<Button variant="primary" onClick={handleProcesar}>
					Guardar
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default EditarCargoDirectiva